import { ColumnConfiguration } from './DataTable.types';

export function shouldRightAlign<T>(column: ColumnConfiguration<T>) {
  return column.type === 'number' || column.type === 'datetime' || column.type === 'actions';
}

export function shouldFitContent<T>(column: ColumnConfiguration<T>) {
  return column.type === 'actions';
}
